import { getCellProperty } from './getCellProperty';

export class NewHeaderCellTemplate {
  getCompatibleCell(uncertainCell: any) {
    const text = getCellProperty(uncertainCell, 'text', 'string');
    const value = parseFloat(text);
    return { ...uncertainCell, text, value };
  }

  render(cell: any, _isInEditMode: boolean, _onCellChanged: (cell: any, commit: boolean) => void) {
    if (cell.render) return cell.render();
    return cell.text;
  }

  isFocusable = (_cell: any): boolean => false;

  getClassName(cell: any, _isInEditMode: boolean) {
    return cell.className ? cell.className : '';
  }

  getStyle = (_cell: any) => {
    return { background: 'rgba(128, 128, 128, 0.1)' };
  };
}
